
export default (id, obj, defaultValue) => {
	if(id === undefined) return defaultValue;
	let idArray = id.split('.')
	let value = obj;
	for (let i in idArray) {
		let key = idArray[i]
		value = value[key]
		if (value === undefined
		|| value === null) return defaultValue;
	}
	return value;
}